/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {simDrawerAnimations as ɵa} from './drawer-animations';